module.exports = __webpack_public_path__ + "static/media/charity-cover.5c35a8bc.png";